<template>
    <div id="tab-detail">
        <div class="header">
            <div class="title">Whatsapp V2 Channel Detail</div>
            <div class="subtitle">Manage your whatsapp v2 channel</div>
        </div>
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>{{ $t("whatsappChannel.channelName") }}</label>
                    <a-input
                        :placeholder="$t('whatsappChannel.channelName')"
                        v-model="clone.name"
                        v-validate="'required'"
                        name="channelName"
                    />
                </div>

                <div class="input-wrapper">
                    <label>{{ $t("whatsapp_business_api.phoneNumberE164") }}</label>
                    <a-input
                        :placeholder="$t('whatsapp_business_api.phoneNumberE164Place')"
                        v-model="clone.payload.phoneNumber"
                        v-validate="'required'"
                        name="phoneNumber"
                    />
                </div>
                <VisibilityChanger v-model="clone.visibility" v-if="showVisibilityConfig" />
            </div>
        </a-form>
        <ChannelForwardSetting :channel="clone" :groupChatbotView="true" @input="(c) => (clone = c)" />
        <div class="form-footer">
            <div class="actions">
                <a-button @click="handleCancel" class="cancel-btn">{{ $t("billing.cancel") }}</a-button>
                <a-button class="pr-confirm-btn" @click="updateChannelData" type="primary" :disabled="loading">
                    {{ $t("billing.save") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { sendSocketMessage } from "../../../utils/socketStream";
import _ from "lodash";
import VisibilityChanger from "../WhatsappV1/VisibilityChanger.vue";
import ChannelForwardSetting from "../IntegrationChannelsItem/ChannelForwardSetting.vue";

export default {
    name: "UpdateDetail",
    components: {
        VisibilityChanger,
        ChannelForwardSetting,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        showVisibilityConfig: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            showStories: false,
            loading: false,
            clone: _.cloneDeep(this.value),
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            siteId: (state) => _.get(state.site.site, "_id"),
            departments: (state) => _.get(state.subject.subjects, "data", []) || [],
        }),
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listStories: "CB/listStories",
            listChannels: "channel/listChannels",
        }),
        toggleChatbot() {
            if (this.showStories) {
                this.clone.forward.stroy = null;
            } else {
                if (this.stories[0]) {
                    this.clone.forward.stroy = this.stories[0]._id;
                }
            }
            this.showStories = !this.showStories;
        },
        toggleDepartmentForwardingRule() {
            console.log("toggleDepartmentForwardingRule", {
                clone: this.clone,
                departments: this.departments,
            });
            if (!!this.clone.forward.department) {
                this.clone.forward.department = null;
            } else {
                if (this.departments[0]) {
                    this.clone.forward.department = this.departments[0]._id;
                }
            }
            this.clone = _.cloneDeep(this.clone);
        },
        handleCancel() {
            this.$emit("cancel");
        },
        checkHaveChatbotStory(id) {
            return this.stories.find((story) => story._id === id);
        },
        getDepartmentTitle(department) {
            const validLangs = Object.keys(department.languageContent);
            const targetLang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
            const key = `languageContent.${targetLang}.name`;
            return _.get(department, key);
        },
        updateChannelData() {
            const isValid = true;
            if (isValid) {
                this.loading = true;
                this.updateChannel(this.clone)
                    .then(() => {
                        this.listChannels();
                        this.$message.success("Channel updated successfully");
                        sendSocketMessage("user wp-channel-updated", {
                            siteId: this.siteId,
                        });
                        this.$emit("input", this.clone);
                        this.clone = _.cloneDeep(this.clone);
                    })
                    .catch((err) => {
                        this.$message.error("Failed to update channel");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
    mounted() {
        this.listStories();
    },
    beforeDestroy() {},
    watch: {
        value: {
            handler: function (val) {
                const isChanged = !_.isEqual(val, this.clone);
                if (isChanged) {
                    log("value changed=>", val);
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
};
</script>
<style scoped lang="scss">
#tab-detail {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;

    .header {
        display: flex;
        justify-content: space-between;
        padding-bottom: 10px;

        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }
}
</style>
